var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpdateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3053",
    "data-name": "Rectangle 3053",
    width: 19,
    height: 19,
    transform: "translate(0)",
    fill: "#5a5a5a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10552",
    "data-name": "Group 10552",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10551",
    "data-name": "Group 10551",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28895",
    "data-name": "Path 28895",
    d: "M18.221,11.023A1.049,1.049,0,0,0,16.9,11.7,7.523,7.523,0,0,1,9.67,16.891,7.48,7.48,0,0,1,2.106,9.514,7.48,7.48,0,0,1,9.67,2.137,7.63,7.63,0,0,1,14.562,3.9L12.28,3.52a1.038,1.038,0,0,0-.789.181,1.063,1.063,0,0,0,.449,1.905l4.465.735h.18a1.105,1.105,0,0,0,.357-.06.312.312,0,0,0,.105-.066A.806.806,0,0,0,17.26,6.1l.093-.115c0-.055.094-.093.138-.159s0-.1.055-.148a1.275,1.275,0,0,0,.072-.187l.789-4.215A1.072,1.072,0,1,0,16.3.875L16.015,2.4A9.672,9.672,0,0,0,0,9.514,9.588,9.588,0,0,0,9.67,19a9.606,9.606,0,0,0,9.285-6.657,1.056,1.056,0,0,0-.734-1.318",
    transform: "translate(0 0)",
    fill: "#5a5a5a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdateIcon);
export default __webpack_public_path__ + "static/media/update-icon.7d9382bf9c93b91b4e0c44c22cd1ddd9.svg";
export { ForwardRef as ReactComponent };